<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZGL8vu/tc-custom/9781626815162.jpg?1728851645585" alt="This image is the cover for the book Deadly Lessons"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deadly Lessons
      </h1>
      <p class="bookDescription body article font2">
        <b>Pamela Smart conspired with her teenage lover to kill her husband. This is her story—told by the acclaimed true crime author of <i>Cellar of Horror</i>.</b><br/>  <br/> Pam and Gregg Smart lived a seemingly storybook existence, the newlyweds very much in love. All of this was shattered when Gregg was senselessly shot to death in 1990. In the trial that followed, staggering revelations came out as to the motive behind the killing: Pam Smart had seduced a fifteen-year-old boy into murdering her husband.<br/>  <br/> Master of true crime Ken Englade paints a portrait of a trial that gripped the nation in its scintillating tale of sex and murder. At its center is a woman who never quite grew up, and the reason why she had her husband murdered is the most stunning twist.<br/>  <br/> “Ken Englade is one of the most astute observers of America’s wild side.” —Jack Olsen, bestselling author of <i>Salt of the Earth</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ken Englade
      </h2>
      
      <p class="authorDescription body article">Kenneth Englade is a New Mexico-based author who has published nine books dealing with high profile trials. <I>Beyond Reason</I>, his book about a University of Virginia coed and her German boyfriend who conspired to kill the woman&rsquo;s parents was a finalist for the Edgar Allan Poe Award. From 2000&ndash;2006 he was a public information officer for the Air Force and the Missile Defense Agency. In 2010 he was inducted into the Hall of Fame at the Louisiana State University School of Mass Communications.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fcd7ce0c